<template>
  <i18n-link
    :style="cssColors"
    :class="$style.root"
    :to="routeObject"
    :dir="dir"
    v-if="style"
  >
    <SvgoArrow :class="$style.svg" />
  </i18n-link>
  <i18n-link
    :style="cssColors"
    :class="$style.root"
    :to="routeObject"
    :dir="dir"
    v-else
  >
    <SvgoArrow :class="$style.svg" />
  </i18n-link>
</template>

<script setup>
const route = useRoute()
const style = ref(null)
const visibility = useDocumentVisibility()

const props = defineProps({
  dir: {
    type: String
  },
  entry: {
    type: Object,
    required: false
  }
})

const routeObject = computed(() => {
  const routeName = getRouteName() === 'editions' ? 'editions-slug-index-about' : getRouteName()
  return {
    name: routeName,
    params: { slug: props?.entry?.slug },
    query: route?.query
  }
})

const colors = computed(() => props?.entry?.colors)
const cssColors = computed(() => getCssColors(colors.value))
</script>

<style module lang="scss">
.root {
  composes: reset-button button-round from global;

  position: fixed;
  z-index: calc(var(--z-index--menu) - 2);
  top: var(--top, calc(50% - var(--size--button) / 2));

  margin: 0 var(--unit--horizontal);
}


.root[dir='prev'] {
  left: var(--left, 0px);
}

.root[dir='next'] {
  left: var(--left, calc(100% - var(--size--button) - var(--unit--horizontal) * 2));
}

.root[dir] {
   @media (max-width: $breakpoint-xs) {
    position: relative;
    margin: 0;
    z-index: 0;
    left: 0;
    right: 0;
    transform: none;
  }
}

.svg {
  composes: button-svg from global;
}

.root[dir='next'] .svg {
  transform: translate(-50%, -50%) rotate(180deg);
}
</style>
